import {
  ColumnData,
  SlideAction,
  SlideLayout,
  SlideLayoutLocationState,
  ViewMode,
} from '@gripp/shared-ui';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ProductDetail } from './productDetail';
import { ProductRoutinesAllColumn } from './productRoutinesAllColumn';

export const ProductRoutinesAll = () => {
  const { productId = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as SlideLayoutLocationState | null;
  const initialTransition =
    locationState?.slideLayoutInitialTransition === SlideAction.NEXT ||
    locationState?.slideLayoutInitialTransition === SlideAction.PREV
      ? locationState.slideLayoutInitialTransition
      : undefined;

  if (!productId) return null;

  const leftColumn: ColumnData = {
    title: 'product.list.products',
    mainComponent: <ProductDetail productId={productId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    backButtonTransitionBehavior: 'concurrent',
    backButtonTransitionExitColumn: 'both',
    onBackButtonPress: () =>
      navigate(`/products/${productId}`, {
        state: { slideLayoutInitialTransition: SlideAction.PREV },
      }),
    disableScroll: false,
  };

  const rightColumn: ColumnData = {
    title: 'product.detail.routines',
    mainComponent: <ProductRoutinesAllColumn productId={productId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    backButtonTransitionBehavior: 'concurrent',
    onBackButtonPress: () =>
      navigate(`/products/${productId}`, {
        state: { slideLayoutInitialTransition: SlideAction.PREV },
      }),
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
      initialTransition={initialTransition}
    />
  );
};
